<template>
    <path d="M1.245 0C.747 0 .308.293.103.742c-.196.46-.108.987.224 1.348L12.058 15 .328 27.91c-.333.361-.42.889-.225 1.348.205.449.644.742 1.142.742H21.25C23.31 30 25 28.31 25 26.25V25h-2.5v1.25c0 .703-.547 1.25-1.25 1.25H4.067l10.598-11.66c.44-.479.44-1.201 0-1.68L4.068 2.5H21.25c.704 0 1.25.547 1.25 1.25V5H25V3.75C25 1.69 23.31 0 21.25 0H1.244z"/>
</template>

<script>
export default {
    name: 'sigmaIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 25 30');
    }
};
</script>
